var map = {
	"./anger1.png": "f5bc",
	"./anger2.png": "9683",
	"./anger3.png": "5ff2",
	"./anger4.png": "c0c3",
	"./back.png": "adb7",
	"./background.png": "92f3",
	"./bling.png": "847e",
	"./box.png": "2426",
	"./boy.png": "5830",
	"./btn.png": "1ced",
	"./cartoon.png": "c033",
	"./end.png": "aec6",
	"./finished-game.png": "b1c6",
	"./finished.png": "58b4",
	"./four.png": "e42f",
	"./frame.png": "5761",
	"./game-level-bg.png": "8523",
	"./happy1.png": "392d",
	"./happy2.png": "7222",
	"./happy3.png": "73a3",
	"./happy4.png": "5786",
	"./index-background.png": "8651",
	"./local-level.png": "6c63",
	"./notice.png": "043d",
	"./one.png": "4963",
	"./pass-child.png": "218e",
	"./pass.png": "a114",
	"./pause.png": "8d53",
	"./prompt.png": "5d56",
	"./scare1.png": "71fc",
	"./scare2.png": "12f8",
	"./scare3.png": "7474",
	"./scare4.png": "d5cb",
	"./sorrow1.png": "0c33",
	"./sorrow2.png": "2ef6",
	"./sorrow3.png": "c8ee",
	"./sorrow4.png": "a1c7",
	"./start.png": "d2e1",
	"./three.png": "6e49",
	"./two.png": "6097"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ed1";